import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages:[],
  unreadCount:0
};

const notificationSlice = createSlice({
  name: 'notificationValues',
  initialState,
  reducers: {
    receive(state,action) {
      const existingMessagesSet = new Set(state.messages.map((message) => `${message.notificationId}`));

      action.payload.messages.forEach((data) => {
        const messageKey = `${data.notificationId}`;
        if (!existingMessagesSet.has(messageKey)) {
          state.messages.unshift(data);
          existingMessagesSet.add(messageKey);
          state.unreadCount += 1;
        }
      });
    },
    receiveAll(state,action) {

      state.messages = action.payload.messages;
      if(action.payload.unreadCount) state.unreadCount = action.payload.unreadCount;
    },
    reset(state){
      state.messages = [];
      state.unreadCount = 0;
    },
    readAll(state) {
      state.messages = state.messages.map((message) => ({
        ...message,
        isRead: true,
      }));
      state.unreadCount = 0;
    },
    readOne(state,action) {
      state.messages = state.messages.flatMap((message) => {
        if(message.notificationId === action.payload.notificationId){
          return {
            ...message,
            isRead: true,
          }
        }
        else{
          return {
            ...message
          }
        }
        });
      state.unreadCount -= 1;
    },
  },
});

export const { receive,readAll,reset,receiveAll,readOne } = notificationSlice.actions;
export default notificationSlice.reducer;